import React from "react";
import PageShell from "./PageShell";
import KpiBar from "./KpiBar";
import SplitLayout from "./SplitLayout";

/**
 * Template D — Monitoring (PDR §6.D)
 * ──────────────────────────────────
 * Purpose : stream events / observe health (Security · SOC · Audit · Storage · Readiness).
 * Slots   : header, healthKpis (5), split { filters, eventStream }.
 */
export default function TemplateMonitoring({
  header, healthKpis, filters, eventStream, testId = "tpl-monitoring",
}) {
  return (
    <PageShell testId={testId}>
      {header}
      {healthKpis && (healthKpis.items
        ? <KpiBar items={healthKpis.items} cols={healthKpis.cols ?? 5} />
        : healthKpis)}
      <SplitLayout side={filters}>{eventStream}</SplitLayout>
    </PageShell>
  );
}
